/*!
 * egt.content.notes — stored show-notes HTML → UA/JSON, with no dependencies.
 *
 * The HTML was already rebuilt through the tag allowlist on ingest
 * (egt.content.kinds sanitizeHTML), so this is a small tokenizer over that known
 * shape, applying the same allowlist again. It is required by the client-
 * registered egt.content.page element's views, so it must stay free of jsdom,
 * fs or path: webpack bundles every static require, and a server-only module
 * here would break the site's whole browser bundle (see 19-FRAMEWORK-GOTCHAS,
 * memory egt-client-registry-no-loadtime-fs).
 *
 * Text is passed through as written: the renderer entity-decodes text nodes
 * once and the DOM escapes them on output.
 */
var TAGS = { p: 1, br: 1, a: 1, strong: 1, em: 1, b: 1, i: 1, ul: 1, ol: 1, li: 1, h3: 1, h4: 1, blockquote: 1, code: 1 };
var VOID = { br: 1 };

function decodeAttr(v) {
  return String(v).replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
}

function safeHref(href) {
  if (/[\u0000-\u001f\s]/.test(href)) { return null; }
  if (/^https:\/\/[^\s"'<>]+$/i.test(href)) { return href; }
  if (/^\/(?![\/\\])[^\s"'<>]*$/.test(href)) { return href; }
  if (/^#[A-Za-z0-9_-]*$/.test(href) || /^mailto:[^\s"'<>]+$/i.test(href)) { return href; }
  return null;
}

function htmlToUA(html) {
  var root = { n: "root", i: [] };
  var stack = [ root ];
  var re = /<(\/?)([a-zA-Z0-9]+)((?:\s+[a-zA-Z-]+(?:="[^"]*")?)*)\s*\/?>|([^<]+)|(<)/g;
  var m;
  var src = String(html || "");
  while ((m = re.exec(src))) {
    var top = stack[stack.length - 1];
    if (m[4] !== undefined || m[5] !== undefined) { top.i.push(m[4] !== undefined ? m[4] : "<"); continue; }
    var closing = m[1] === "/", tag = m[2].toLowerCase();
    if (!TAGS[tag]) { continue; }                       // unknown tag: drop the tag, keep its text
    if (closing) {
      for (var k = stack.length - 1; k > 0; k--) {
        if (stack[k].n === tag) { stack.length = k; break; }
      }
      continue;
    }
    var node = { n: tag, i: [] };
    if (tag === "a") {
      var hm = /\shref="([^"]*)"/i.exec(m[3] || "");
      var href = hm ? safeHref(decodeAttr(hm[1])) : null;
      if (href) {
        node.href = href;
        if (/^https:/i.test(href)) { node.target = "_blank"; node.rel = "noopener noreferrer"; }
      } else { node.strip = true; }                      // unsafe link: keep its text only
    }
    if (VOID[tag]) { delete node.i; top.i.push(node); continue; }
    top.i.push(node);
    stack.push(node);
  }
  return clean(root.i);
}

function clean(list) {
  var out = [];
  (list || []).forEach(function (x) {
    if (typeof x === "string") { if (x.length) { out.push(x); } return; }
    var kids = x.i ? clean(x.i) : undefined;
    if (x.strip) { out = out.concat(kids || []); return; }
    var node = { n: x.n };
    if (x.href) { node.href = x.href; }
    if (x.target) { node.target = x.target; node.rel = x.rel; }
    if (kids !== undefined) { node.i = kids; }
    out.push(node);
  });
  return out;
}

exports.htmlToUA = htmlToUA;
